import { initSocket } from "./socketInstance";
import { registerSocketListeners } from "./socketListeners";
import { registerVisibilityChange } from "./visibility";
 
let socketInitialized = false;

export const setupSocket = (dispatch) => {
  console.count("setupSocket called");

  const socket = initSocket();

  if (!socketInitialized) {
    socketInitialized = true;
    registerSocketListeners(socket, dispatch);
  }

  registerVisibilityChange(socket); // ⬅️ امن، حتی اگر چندبار صدا بخوره

  if (!socket.connected) {
    socket.connect();
  }

  return socket;
};
